import { createContext } from 'react';

const featureFlags = {};
export default createContext(featureFlags);
